import React, { useState } from "react";
import { FilterSingleSelect } from "@simpleview/sv-mosaic";

export default function SelectWrap(props){
	const [selectState, setSelectState] = useState({
		value : undefined
	});

	const getOptions = function() {
		return {
			docs : props.options,
			hasMore : false
		}
	}

	const getSelected = function(id) {
		if(id === undefined && document.querySelectorAll(`input[name=${props.name}]`)[0].value !== undefined) {
			id = document.querySelectorAll(`input[name=${props.name}]`)[0].value;
			setSelectState({ value : id }); // Set initial value
		}
		return props.options.filter((val) => String(val.value) === String(id))[0];
	}

	const onChange = function(changeData) {
		setSelectState(changeData);
		const newValue = (changeData.value !== undefined ? changeData.value : "");
		document.querySelectorAll(`input[name=${props.name}]`)[0].value=newValue;
	}

	return (
		<FilterSingleSelect label={props.label}
			type="primary"
			data={selectState}
			args={{ getOptions, getSelected }}
			onRemove={function(){}}
			onChange={onChange}
		/>
	);
}
